import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import InputField from '../InputField'

// NOTE: See InputField component for all props

// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  wrapper: {
    '& input::-webkit-clear-button': {
      marginRight: '4px',
    },
  },
})

function TimeSelector(props) {
  const { classes, className, defaultValue, label, minIncrement, value, ...rest } = props

  return (
    // biome-ignore lint/complexity/noUselessFragments: TODO
    <>
      <InputField
        defaultValue={defaultValue}
        className={cn(classes.wrapper, className)}
        inputProps={{
          step: minIncrement,
        }}
        value={value}
        label={label}
        type="time"
        {...rest}
      />
    </>
  )
}

TimeSelector.defaultProps = {
  defaultValue: '09:00',
  minIncrement: 300,
}

const TimeSelectorComponent = withStyles(styles)(TimeSelector)
TimeSelectorComponent.displayName = 'TimeSelector'
export default TimeSelectorComponent
